import { useDashboardFilter } from '@/hooks';
import { education } from '@/services';
import { Data } from 'big-data';
import { useEffect, useMemo, useState } from 'react';

const requests = [
  education.getNurseryParentInterests,
  education.getPreschoolParentInterests,
  education.getSchoolParentInterests
];

export function useParentInterestsData() {
  const [parentInterests, setParentInterests] = useState<Data[]>([]);
  const [parentInterestError, setParentInterestsError] = useState<Error | null>(
    null
  );
  const [parentInterestLoading, setParentInterestLoading] = useState(false);

  const { ibge, year, semester, zone } = useDashboardFilter();

  useEffect(() => {
    setParentInterestLoading(true);
    Promise.all(
      requests.map((request) => request({ ibge, year, semester, zone }))
    )
      .then((data) => data.flat())
      .then((data) => {
        const sortedData = [...data].sort((a, b) => b.value - a.value);
        setParentInterests(sortedData);
      })
      .catch((error) => setParentInterestsError(error))
      .finally(() => setParentInterestLoading(false));
  }, [ibge, year, semester, zone]);

  return useMemo(
    () => ({
      parentInterests,
      parentInterestLoading,
      parentInterestError
    }),
    [parentInterests, parentInterestLoading, parentInterestError]
  );
}
